import React from "react";
import { Chip } from "@mui/material";

export const ChipSmall = ({ children }) => (
  <Chip label={children} sx={{ mr: 1 }} size="small" />
);
